<template>
    <svg viewBox="0 0 16 16">
        <path :fill="path.fill" :d="path.d" v-for="path in paths"/>
    </svg>
</template>
<script>
export default {
    name: 'i-svg',
    data() {
        return {
            paths: [{
                    fill: "#9e9e9e",
                    d: "M6.7 16l9.3-9.3v-1.4l-10.7 10.7z"
                },
                {
                    fill: "#9e9e9e",
                    d: "M9.7 16l6.3-6.3v-1.4l-7.7 7.7z"
                },
                {
                    fill: "#9e9e9e",
                    d: "M12.7 16l3.3-3.3v-1.4l-4.7 4.7z"
                },
                {
                    fill: "#9e9e9e",
                    d: "M15.7 16l0.3-0.3v-1.4l-1.7 1.7z"
                },
            ]
        }
    }
}
</script>
<style lang="css" scoped>
</style>